import React from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';

function Home() {
  /*
  This component renders the home page of the application.
  */
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/dealer-select');
  };

  return (
    <div className="App-content">
      <img src="/components/logo.png" alt="Logo" className="App-logo" />
      <h1 className="App-title">DIY Photography</h1>
      <button className="App-button" onClick={handleButtonClick}>Let's Begin</button>
    </div>
  );
}

export default Home;
